// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -------------------------------------------------------
   GLOBAL CONTAINER
------------------------------------------------------- */
.onboarding-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100vh;
  background: #f4f6f9;
  padding: 40px 20px;
  font-family: "Inter", sans-serif;
}

/* -------------------------------------------------------
   LOGO
------------------------------------------------------- */
.onboarding-logo {
  width: 180px;
  margin-bottom: 20px;
}

/* -------------------------------------------------------
   BACK BUTTON
------------------------------------------------------- */
.back-button {
  align-self: flex-start;
  margin-bottom: 10px;
  background: none;
  border: none;
  color: #4a90e2;
  font-size: 16px;
  cursor: pointer;
  padding: 0;
  margin-left: 10px;
  transition: color 0.2s;
}

.back-button:hover {
  color: #2f6bb2;
}

/* -------------------------------------------------------
   CARD
------------------------------------------------------- */
.onboarding-card {
  width: 100%;
  max-width: 520px;
  background: white;
  padding: 32px;
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.08);
  animation-duration: 0.45s;
  animation-fill-mode: both;
  text-align: left; /* IMPORTANT: prevents inherited centering */
}

/* -------------------------------------------------------
   ANIMATIONS
------------------------------------------------------- */
@keyframes slideIn {
  from { opacity: 0; transform: translateX(40px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes slideBack {
  from { opacity: 0; transform: translateX(-40px); }
  to { opacity: 1; transform: translateX(0); }
}

.slide-in { animation-name: slideIn; }
.slide-back { animation-name: slideBack; }

/* -------------------------------------------------------
   LABELS
------------------------------------------------------- */
.onboarding-card label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #2c3e50;
}

/* -------------------------------------------------------
   INPUTS
------------------------------------------------------- */
.onboarding-card input:not([type="radio"]),
.onboarding-card select {
  /* width: 90%; */
  padding: 12px 14px;
  margin-bottom: 18px;
  border: 1px solid #d0d7e2;
  border-radius: 8px;
  font-size: 15px;
  transition: border 0.2s;
  background: #fafbfc;
}

.onboarding-card input:focus,
.onboarding-card select:focus {
  border-color: #4a90e2;
  outline: none;
}

/* -------------------------------------------------------
   BUTTON
------------------------------------------------------- */
.onboarding-card button {
  width: 100%;
  padding: 14px;
  background: #4a90e2;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 10px;
  transition: background 0.2s;
}

.onboarding-card button:hover {
  background: #3b7ac4;
}

/* -------------------------------------------------------
   PROGRESS DOTS
------------------------------------------------------- */
.onboarding-progress {
  display: flex;
  gap: 8px;
  margin-top: 24px;
}

.progress-dot {
  width: 10px;
  height: 10px;
  background: #d0d7e2;
  border-radius: 50%;
  transition: background 0.3s;
}

.progress-dot.active {
  background: #4a90e2;
}

/* -------------------------------------------------------
   ERROR TEXT
------------------------------------------------------- */
.error {
  color: #d9534f;
  font-size: 13px;
  margin-top: -12px;
  margin-bottom: 12px;
}

/* -------------------------------------------------------
   FORM GROUP
------------------------------------------------------- */
.form-group {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
}

/* -------------------------------------------------------
   RADIO GROUP — FINAL, BULLETPROOF FIX
------------------------------------------------------- */
.radio-group {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 20px;
  width: 100%;
  text-align: left;
}

.radio-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;
  text-align: left;
}

.radio-option input[type="radio"] {
  width: auto;
  margin: 0;
  transform: scale(1.1);
}

.radio-option span {
  display: inline-block;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/onboarding/onboarding.css"],"names":[],"mappings":"AAAA;;yDAEyD;AACzD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;;yDAEyD;AACzD;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;yDAEyD;AACzD;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;;yDAEyD;AACzD;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB,EAAE,4CAA4C;AAChE;;AAEA;;yDAEyD;AACzD;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,YAAY,uBAAuB,EAAE;AACrC,cAAc,yBAAyB,EAAE;;AAEzC;;yDAEyD;AACzD;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;yDAEyD;AACzD;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA;;yDAEyD;AACzD;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;yDAEyD;AACzD;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;yDAEyD;AACzD;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;yDAEyD;AACzD;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;yDAEyD;AACzD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB","sourcesContent":["/* -------------------------------------------------------\n   GLOBAL CONTAINER\n------------------------------------------------------- */\n.onboarding-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  min-height: 100vh;\n  background: #f4f6f9;\n  padding: 40px 20px;\n  font-family: \"Inter\", sans-serif;\n}\n\n/* -------------------------------------------------------\n   LOGO\n------------------------------------------------------- */\n.onboarding-logo {\n  width: 180px;\n  margin-bottom: 20px;\n}\n\n/* -------------------------------------------------------\n   BACK BUTTON\n------------------------------------------------------- */\n.back-button {\n  align-self: flex-start;\n  margin-bottom: 10px;\n  background: none;\n  border: none;\n  color: #4a90e2;\n  font-size: 16px;\n  cursor: pointer;\n  padding: 0;\n  margin-left: 10px;\n  transition: color 0.2s;\n}\n\n.back-button:hover {\n  color: #2f6bb2;\n}\n\n/* -------------------------------------------------------\n   CARD\n------------------------------------------------------- */\n.onboarding-card {\n  width: 100%;\n  max-width: 520px;\n  background: white;\n  padding: 32px;\n  border-radius: 14px;\n  box-shadow: 0 8px 24px rgba(0,0,0,0.08);\n  animation-duration: 0.45s;\n  animation-fill-mode: both;\n  text-align: left; /* IMPORTANT: prevents inherited centering */\n}\n\n/* -------------------------------------------------------\n   ANIMATIONS\n------------------------------------------------------- */\n@keyframes slideIn {\n  from { opacity: 0; transform: translateX(40px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n@keyframes slideBack {\n  from { opacity: 0; transform: translateX(-40px); }\n  to { opacity: 1; transform: translateX(0); }\n}\n\n.slide-in { animation-name: slideIn; }\n.slide-back { animation-name: slideBack; }\n\n/* -------------------------------------------------------\n   LABELS\n------------------------------------------------------- */\n.onboarding-card label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 6px;\n  color: #2c3e50;\n}\n\n/* -------------------------------------------------------\n   INPUTS\n------------------------------------------------------- */\n.onboarding-card input:not([type=\"radio\"]),\n.onboarding-card select {\n  /* width: 90%; */\n  padding: 12px 14px;\n  margin-bottom: 18px;\n  border: 1px solid #d0d7e2;\n  border-radius: 8px;\n  font-size: 15px;\n  transition: border 0.2s;\n  background: #fafbfc;\n}\n\n.onboarding-card input:focus,\n.onboarding-card select:focus {\n  border-color: #4a90e2;\n  outline: none;\n}\n\n/* -------------------------------------------------------\n   BUTTON\n------------------------------------------------------- */\n.onboarding-card button {\n  width: 100%;\n  padding: 14px;\n  background: #4a90e2;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  cursor: pointer;\n  margin-top: 10px;\n  transition: background 0.2s;\n}\n\n.onboarding-card button:hover {\n  background: #3b7ac4;\n}\n\n/* -------------------------------------------------------\n   PROGRESS DOTS\n------------------------------------------------------- */\n.onboarding-progress {\n  display: flex;\n  gap: 8px;\n  margin-top: 24px;\n}\n\n.progress-dot {\n  width: 10px;\n  height: 10px;\n  background: #d0d7e2;\n  border-radius: 50%;\n  transition: background 0.3s;\n}\n\n.progress-dot.active {\n  background: #4a90e2;\n}\n\n/* -------------------------------------------------------\n   ERROR TEXT\n------------------------------------------------------- */\n.error {\n  color: #d9534f;\n  font-size: 13px;\n  margin-top: -12px;\n  margin-bottom: 12px;\n}\n\n/* -------------------------------------------------------\n   FORM GROUP\n------------------------------------------------------- */\n.form-group {\n  margin-bottom: 20px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* -------------------------------------------------------\n   RADIO GROUP — FINAL, BULLETPROOF FIX\n------------------------------------------------------- */\n.radio-group {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  margin-bottom: 20px;\n  width: 100%;\n  text-align: left;\n}\n\n.radio-option {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n  width: 100%;\n  text-align: left;\n}\n\n.radio-option input[type=\"radio\"] {\n  width: auto;\n  margin: 0;\n  transform: scale(1.1);\n}\n\n.radio-option span {\n  display: inline-block;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
